// @flow
import React, { Component } from "react";
import styles from "./SeverityRating.module.css";
import Label from "./Label/Label";

type Props = {
  severity: number,
  showLabel?: boolean
};

class SeverityRating extends Component<Props, void> {
  static defaultProps = {
    showLabel: false
  };

  renderRating = () => {
    const { severity } = this.props;
    const ratings = [];
    for (let index = 1; index <= 5; index += 1) {
      ratings.push(
        <span
          key={index}
          className={
            severity >= index ? styles.ratingUnitActive : styles.ratingUnit
          }
        />
      );
    }
    return ratings;
  };

  render() {
    const { showLabel, severity } = this.props;
    return (
      <div className={styles.wrapper}>
        {this.renderRating()}
        {showLabel && <Label severity={severity} />}
      </div>
    );
  }
}

export default SeverityRating;



// WEBPACK FOOTER //
// ./src/components/shared/SeverityRating/SeverityRating.js